(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const params = new URLSearchParams(window.location.search);
    const activeView = params.get('zdoya_view');

    const sections = document.querySelectorAll('[data-zdoya-view]');

    sections.forEach((section) => {
      const view = section.dataset.zdoyaView;

      if (view && view !== activeView) {
        section.hidden = true;
      }

      if (!view) {
        section.hidden = false;
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
